export default {
  name: "AuthGuide",
  data() {
    return {
      width: document.documentElement.clientWidth || document.body.clientWidth,
      height: document.documentElement.clientHeight || document.body.clientHeight
    };
  },
  mounted() {},
  methods: {}
};